import axios from 'axios'
import qs from 'qs'

let api = {
  getBanner: (params, config) => {
    return axios.post('/cmsbanner/list', qs.stringify(params), config)
  },
  lawyerTeam: (params, config) => {
    return axios.post('/lawyerinfo/list', qs.stringify(params), config)
  },
  lawyerProduct: (params, config) => {
    return axios.post('/ltagawyerproduct/list', qs.stringify(params), config)
  },
  getCmscontentsubject: (params, config) => {
    return axios.post('/cmscontentsubject/list', qs.stringify(params), config)
  },
  getCmscontent: (params, config) => {
    return axios.post('/cmscontent/list', qs.stringify(params), config)
  },
  getNewDetail: (id, params, config) => {
    return axios.post(`/cmscontent/info/${id}`, qs.stringify(params), config)
  }
}

export default api



// WEBPACK FOOTER //
// ./src/common/api/api.js